import { LocalizedPack } from 'apollo/localizedTypes';
import { Mode } from 'components/sharedComponents/FormModal/types';

const setEditOrCreateForm = (
  item: LocalizedPack | undefined,
  setEditItem: React.Dispatch<React.SetStateAction<LocalizedPack | undefined>>,
  setModalMode: React.Dispatch<React.SetStateAction<Mode | undefined>>,
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>
): void => {
  setEditItem(item);
  if (item) {
    setModalMode('edit');
  } else {
    setModalMode('create');
  }
  setIsModalVisible(true);
};

export default setEditOrCreateForm;
